import { updatesData } from '@/mocks/home';

const typeStyles: Record<string, { bg: string; text: string; dot: string }> = {
  new: { bg: 'bg-primary-100', text: 'text-primary-700', dot: 'bg-primary-400' },
  update: { bg: 'bg-secondary-100', text: 'text-secondary-700', dot: 'bg-secondary-400' },
  rank: { bg: 'bg-accent-100', text: 'text-accent-700', dot: 'bg-accent-400' },
  feature: { bg: 'bg-foreground-100', text: 'text-foreground-700', dot: 'bg-foreground-400' },
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-primary-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">最新动态</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">共9条快讯 · 实时滚动更新</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {updatesData.map((item, index) => {
            const style = typeStyles[item.type] || typeStyles.update;
            return (
              <div
                key={index}
                className={`group flex items-start gap-3.5 p-4 rounded-xl border transition-all cursor-pointer ${
                  item.highlight
                    ? 'bg-background-50 border-primary-200 hover:border-primary-300'
                    : 'bg-background-50 border-background-200/70 hover:border-foreground-200'
                }`}
              >
                <div className={`w-2 h-2 rounded-full mt-2 shrink-0 ${item.highlight ? 'bg-primary-500 animate-pulse' : style.dot}`} />
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-medium mb-1.5 leading-relaxed ${item.highlight ? 'text-foreground-900' : 'text-foreground-800'}`}>
                    {item.title}
                  </p>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className={`inline-block px-2 py-0.5 text-[11px] font-medium rounded ${style.bg} ${style.text}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                </div>
                {item.highlight && (
                  <div className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0 mt-1">
                    <i className="ri-notification-3-line" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}